export default "__VITE_ASSET__ChSaJz0r__"